import AdministrativeInfo from "./AdministrativeInfo";
import MeetingHistory from "../MeetingHistory";
import {
  StudentLimitedResponse,
  ParentAdminResponse,
  ParentLimitedResponse,
  Auth0AccountRole,
} from "client/openapi";
import Parents from "./Parents";
import Subjects from "./Subjects";
import Tutors from "./Tutors";
import PersonFormsSection from "components/Forms/PersonFormsSection";
import PersonTasksSection from "components/Tasks/PersonTasksSection";
import { useContext, useState } from "react";
import { OrgRolesAndAccountContext } from "util/OrgRolesAccountContext";

export default function AdditionalStudentInfoTab({
  student,
  organization_id,
  exportingMeetings,
  setExportingMeetings,
  setStatus,
  setError,
  orgParents,
  studentParents,
  setStudentParents,
}: {
  student: StudentLimitedResponse;
  organization_id: number;
  exportingMeetings: boolean;
  setExportingMeetings: (boolean) => void;
  setStatus: (PageStatus) => void;
  setError: (APIResponse) => void;
  orgParents: ParentAdminResponse[] | ParentLimitedResponse[];
  studentParents: ParentAdminResponse[] | ParentLimitedResponse[];
  setStudentParents: (
    students: ParentAdminResponse[] | ParentLimitedResponse[]
  ) => void;
}) {
  const [exportingData, setExportingData] = useState<boolean>(false);
  const { currently_selected_role } = useContext(OrgRolesAndAccountContext);

  return (
    <div className="grid grid-cols-1 items-start gap-5 lg:grid-cols-3">
      {currently_selected_role &&
        [Auth0AccountRole.ORG_ADMIN, Auth0AccountRole.ORG_TUTOR].includes(
          currently_selected_role
        ) && (
          <>
            <div className="flex">
              <AdministrativeInfo
                exportingData={exportingData}
                setExportingData={setExportingData}
                userType={Auth0AccountRole.ME}
                student={student}
                organization_id={organization_id}
                exportingMeetings={exportingMeetings}
                setStatus={setStatus}
                setError={setError}
              />
            </div>
          </>
        )}

      <div className="flex flex-col gap-5">
        <Parents
          student={student}
          orgParents={orgParents}
          studentParents={studentParents}
          setStudentParents={setStudentParents}
        />
        {/* Admins only, as on the tutor page's Students. */}
        {currently_selected_role === Auth0AccountRole.ORG_ADMIN && (
          <Tutors studentId={student.id} orgId={organization_id} />
        )}
        <Subjects student={student} organization_id={organization_id} />
        <PersonTasksSection
          orgId={organization_id}
          personType={Auth0AccountRole.ME}
          personId={student.id}
        />
        {currently_selected_role === Auth0AccountRole.ORG_ADMIN && (
          <PersonFormsSection
            orgId={organization_id}
            personType={Auth0AccountRole.ME}
            personId={student.id}
          />
        )}
      </div>

      <div className="flex">
        <MeetingHistory
          exportingMeetings={exportingMeetings}
          setExportingMeetings={setExportingMeetings}
          student={student}
          exportingData={exportingData}
          setStatus={setStatus}
          setError={setError}
        />
      </div>
    </div>
  );
}
